// extracted by mini-css-extract-plugin
export default {"centre":"SearchCard_centre__oIqKT","duration":"SearchCard_duration__ZqekK","bow":"SearchCard_bow__pLCAT","buttonDiv":"SearchCard_buttonDiv__uxv0W"};